import { Box, Typography } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";

function RenderRte(props: PropsType) {
  const element = useRef<HTMLDivElement | null>(null);
  const [displayText, setDisplayText] = useState<string | undefined>(props.rte);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  useEffect(() => {
    if (props.rte) {
      // Count words
      const words = props.rte.split(/\s+/); // Split by whitespace
      const wordLimit = 20;
      const previewLimit = 20;

      // If content exceeds wordLimit, show only the first previewLimit words
      if (words.length > wordLimit) {
        const truncated = words.slice(0, previewLimit).join(" ") + "...";
        setDisplayText(truncated);
      } else {
        setDisplayText(props.rte); // Show the full content if under wordLimit
      }
    }
  }, [props.rte]);

  const toggleContent = () => {
    setIsExpanded((prev) => !prev); // Toggle between showing full and truncated content
  };

  // Check if `more` prop is true, then use the expanded view
  if (props.more) {
    return (
      <Box>
        <div
          ref={element}
          dangerouslySetInnerHTML={{
            __html: isExpanded ? props.rte || "" : displayText || "",
          }}
        />
        {/* Show "See more" or "See less" depending on the current state */}
        {props.rte && props.rte.split(/\s+/).length > 20 && (
          <Typography
            sx={{
              marginTop: "4px",
              cursor: "pointer",
              fontWeight: "700",
              textDecoration: "underline",
            }}
            onClick={toggleContent}
          >
            {isExpanded ? "See less" : "See more"}
          </Typography>
        )}
      </Box>
    );
  }

  // If `more` is false or not provided, just render the content without truncation
  return (
    <div ref={element} dangerouslySetInnerHTML={{ __html: props.rte || "" }} />
  );
}

export default RenderRte;

type PropsType = {
  rte?: string;
  more?: boolean;
};
